//Array From Polyfill
// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = (function() {
    var toStr = Object.prototype.toString;
    var isCallable = function(fn) {
      return typeof fn === "function" || toStr.call(fn) === "[object Function]";
    };
    var toInteger = function(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError(
          "Array.from requires an array-like object - not null or undefined"
        );
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== "undefined") {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError(
            "Array.from: when provided, the second argument must be a function"
          );
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] =
            typeof T === "undefined"
              ? mapFn(kValue, k)
              : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  })();
}

//init GTM Tracking Global Object

//Define the dataLayer if it doesn't exist already
window.dataLayer = window.dataLayer || [];

if (!window.gtmTracking) {
  //console.log('init gtmTracking');

  window.gtmTracking = {
    GTM_BRAND: "Oxford University Press",
    getGtmElementData: function(element) {
      var obj = {};

      //console.log('GTM Data Element: ', element);

      if (typeof element !== undefined) {
        //console.log('element.dataset: ',element.dataset);

        // GA4 frienlty properties
        obj.affiliation = "Oxford University Press";
        obj.item_id = element.dataset.gtmId || "";
        obj.item_name = element.dataset.gtmName || "";
        obj.item_category = element.dataset.gtmCategory || "";
        obj.item_brand = this.GTM_BRAND; //'Oxford University Press', // irrelevant hard coded value - should be set as Constant?
        obj.item_variant = element.dataset.gtmVariant || "";

        obj.id = element.dataset.gtmId || "";
        obj.name = element.dataset.gtmName || "";
        obj.price = element.dataset.gtmPrice.replace(/[^0-9.-]+/g, "") || "";
        obj.brand = this.GTM_BRAND; //'Oxford University Press', // irrelevant hard coded value - should be set as Constant?
        obj.category = element.dataset.gtmCategory || "";
        obj.variant = element.dataset.gtmVariant || "";
        obj.bookId = element.dataset.gtmBookId || "";
        obj.quantity = parseInt(element.dataset.gtmQuantity, 10) || "";
        obj.stockAtHand = parseInt(element.dataset.gtmStockAtHand, 10) || "";

        return obj;
      } else {
        console.warn("GTM Tracking Data Not Found!");
      }
    }
  };
}

//GTM Cart Step Tracking
function gtmGetCheckoutStep() {
  //var $stepElm  = $('[data-gtm-checkout-step]')[0];

  //console.log('init gtmGetCheckoutStep');
  var stepElm = document.querySelector("[data-gtm-checkout-step]");
  var couponElm = document.querySelector("[data-gtm-coupon]") || "";
  var emailElm = document.querySelector("[data-gtm-email]") || "";
  var totalSubElm = document.querySelector("[data-gtm-total-sub]") || "";
  var totalDeliveryElm =
    document.querySelector("[data-gtm-total-delivery]") || "";
  var totalTaxElm = document.querySelector("[data-gtm-total-tax]") || "";
  var totalPurchaseElm =
    document.querySelector("[data-gtm-total-purchase]") || "";

  if (stepElm) {
    var step = stepElm.dataset.gtmCheckoutStep;
    var coupon = couponElm ? couponElm.dataset.gtmCoupon : "";
    var email = emailElm ? emailElm.dataset.gtmEmail : "";
    var totalSub = totalSubElm ? totalSubElm.dataset.gtmTotalSub : "";
    var totalDelivery = totalDeliveryElm
      ? totalDeliveryElm.dataset.gtmTotalDelivery
      : "";
    var totalTax = totalTaxElm ? totalTaxElm.dataset.gtmTotalTax : "";
    var totalPurchase = totalPurchaseElm
      ? totalPurchaseElm.dataset.gtmTotalPurchase
      : "";

    //data-gtm-coupon="%globals_asset_get_applied_promotion_code:149894%"

    //console.log('step:',step);
    //console.log('coupon:',step);
    //console.log('email:',email);

    var dataElms = document.querySelectorAll(".gtm-product-data");
    var elmsArr = Array.from(dataElms);

    var dataArr = elmsArr.map(function(item) {
      var dataItem = gtmTracking.getGtmElementData(item);
      dataItem.email = email;
      dataItem.coupon = coupon;

      return dataItem;
    });

    // here we populate the default payment option field ONLY on the Delivery Step
    //var paymentOption = step === 'delivery' ? 'Credit Card' : '';
    var paymentOption = step == "2" ? "Credit Card" : "";

    // If step 5 (receipt) page send purchase event, otherwise checkout
    // Need to strip out any non-number characters (dollar sign)
    // str.replace(/[^0-9.-]+/g,"");
    if (step == 5) {
      var orderIdElm = document.querySelector("#order_id") || "";
      var orderId = orderIdElm.textContent.replace("Order ID: ", "");

      dataLayer.push({ ecommerce: null });

      dataLayer.push({
        event: "purchase",
        ecommerce: {
          currencyCode: "AUD",
          purchase: {
            actionField: {
              id: orderId,
              affiliation: "Oxford University Press",
              revenue: totalPurchase.replace(/[^0-9.-]+/g, ""),
              tax: totalTax.replace(/[^0-9.-]+/g, ""),
              shipping: totalDelivery.replace(/[^0-9.-]+/g, ""),
              coupon: coupon
            },
            products: dataArr || []
          }
        }
      });

        // GA4 events
        dataLayer.push({
            event : "purchase",
            ecommerce : {
                transaction_id: orderId,
                currency : "AUD",
                shipping: totalDelivery.replace(/[^0-9.-]+/g, ""),
                coupon: coupon,
                tax: totalTax.replace(/[^0-9.-]+/g, ""),
                items: dataArr || []
            }
        });
    } else {
      dataLayer.push({ ecommerce: null });

      window.dataLayer.push({
        event: "checkout",
        ecommerce: {
          currencyCode: "AUD",
          checkout: {
            actionField: {
              step: step,
              coupon: coupon,
              option: paymentOption
            },
            products: dataArr || []
          }
        }
      });

        window.dataLayer.push({
            event : "begin_checkout",
            ecommerce : {
                currency : "AUD",
                coupon: coupon,
                products: dataArr || []
            }
        });
    }
  } else {
    //console.log('no checkout steps')
  }
}

gtmGetCheckoutStep();
